<div class="role-features">
  <div class="toolbar">
    <div class="permission-search">
      <app-search-input
        [(ngModel)]="localSearchString"
        [disabled]="isLocalSearchDisabled"
        [placeholder]="
          isLocalSearchDisabled
            ? 'Global search active'
            : 'Type to filter the list of effective user permissions'
        "
      ></app-search-input>
    </div>
    <div class="show-selected">
      <sui-checkbox
        [ngModel]="showSelectedOnly"
        [ngModelOptions]="{ standalone: true }"
        (checkedChange)="onShowSelectedOnlyChange($event)"
      >
        {{ "editor-role.label.show-selected-only" | translate }}
      </sui-checkbox>
    </div>

    <div class="features-counter">
      <span>{{ getSelectedComponentsCount() }}</span>
      {{ "editor-role.label.features-enabled-out-of" | translate }}
      <span>{{ getTotalComponentsCount() }}</span>
    </div>
  </div>
  <div class="features-container">
    @for (roleModule of getFilteredModules(); track roleModule) {
      <div>
        <div class="module-title">
          <label>
            @if (
              roleModule?.root_component &&
              shouldShowRootComponent(roleModule.root_component)
            ) {
              <sui-checkbox
                [ngModel]="
                  $safeNavigationMigration(roleModule?.root_component.selected)
                "
                [ngModelOptions]="{ standalone: true }"
                (checkedChange)="
                  onComponentChange(roleModule.root_component, $event)
                "
              ></sui-checkbox>
            }
            <span [innerHTML]="roleModule.name | highlight: activeSearchString">
            </span>
          </label>
          @if (
            roleModule?.root_component &&
            shouldShowRootComponent(roleModule.root_component)
          ) {
            <sui-checkbox
              [ngModel]="isModuleFullySelected(roleModule)"
              [ngModelOptions]="{ standalone: true }"
              (checkedChange)="toggleModuleSelection($event, roleModule)"
            >
              {{ "editor-role.label.toggle-module" | translate }}
            </sui-checkbox>
          }
        </div>
        @for (
          component of getFilteredChildComponents(roleModule.components);
          track component
        ) {
          <div class="module-items">
            <sui-checkbox
              [ngModel]="component.selected"
              [ngModelOptions]="{ standalone: true }"
              (checkedChange)="onComponentChange(component, $event)"
            >
              <span
                [innerHTML]="component.name | highlight: activeSearchString"
              >
              </span>
            </sui-checkbox>
          </div>
        }
      </div>
    }
  </div>
</div>
